var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-76.8 -76.8 665.60 665.60",
    xmlSpace: "preserve",
    width: "184px",
    height: "184px",
    fill: "#000000",
    transform: "rotate(-45)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D3CF"
    },
    d: "M414.717,139.649l86.527-86.527l-42.366-42.364l-86.525,86.528 c-33.986-20.926-79.08-16.683-108.533,12.769L20.106,353.768c-16.665,16.665-16.665,43.683-0.002,60.347l77.782,77.781 c16.663,16.664,43.681,16.663,60.346-0.001L401.945,248.18C431.399,218.728,435.642,173.636,414.717,139.649z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.464,
    y: 25.055,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 756.7625 410.6189)",
    style: {
      fill: "#FF6A5E"
    },
    width: 59.918,
    height: 47.048
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.877,
    y: 202.169,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -127.9612 215.9389)",
    style: {
      fill: "#F59D40"
    },
    width: 223.608,
    height: 120.526
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.812,
    y: 222.538,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 228.1121 554.7761)",
    style: {
      fill: "#FFFFFF"
    },
    width: 70.283,
    height: 15.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.289,
    y: 244.065,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 176.1477 576.3046)",
    style: {
      fill: "#FFFFFF"
    },
    width: 70.283,
    height: 15.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.775,
    y: 265.573,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 124.2136 597.8088)",
    style: {
      fill: "#FFFFFF"
    },
    width: 70.283,
    height: 15.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.269,
    y: 287.087,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 72.2873 619.3286)",
    style: {
      fill: "#FFFFFF"
    },
    width: 70.283,
    height: 15.213
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#311363"
    },
    d: "M512,53.122L512,53.122l-7.589-7.589L458.878,0l-0.001,0.001l0,0L414.85,44.029h0.001l-43.767,43.768 c-13.781-7.32-29.194-11.164-44.937-11.164c-25.576,0-49.621,9.959-67.706,28.043L14.728,348.39 c-9.497,9.496-14.727,22.123-14.727,35.553c0,13.43,5.229,26.056,14.725,35.552l77.782,77.781 c9.495,9.495,22.12,14.725,35.55,14.726c0.001,0,0.002,0,0.003,0c13.428,0,26.054-5.23,35.55-14.727l243.716-243.715 c15.326-15.327,25.078-35.607,27.458-57.107c2.121-19.142-1.627-38.634-10.582-55.531l43.77-43.77l0,0l29.353-29.354L512,53.122 L512,53.122z M467.971,75.638L436.363,44.03l22.513-22.514l31.61,31.606L467.971,75.638z M408.239,143.637 c19.631,31.884,14.832,72.662-11.672,99.165L152.853,486.517c-6.624,6.624-15.427,10.271-24.792,10.271c-0.001,0-0.002,0-0.003,0 c-9.367-0.001-18.171-3.648-24.793-10.27l-1.237-1.237l11.001-11l-10.757-10.757l-11.001,11l-10.76-10.759l11-11.001l-10.757-10.757 l-11.001,11.001l-10.76-10.76l11.001-11.002l-10.757-10.757l-11.002,11.002l-10.76-10.76l11.001-11.001l-10.757-10.757 l-11.001,11.001l-1.237-1.237c-6.623-6.626-10.27-15.431-10.27-24.797s3.648-18.172,10.271-24.796l49.519-49.519l50.807,50.807 l10.757-10.757L85.76,298.871l147.357-147.358l74.467,74.467L160.229,373.338l-12.429-12.43l-10.757,10.757l23.187,23.188 L329.101,225.98l-85.225-85.225l10.76-10.76l65.502,65.503l10.758-10.757l-65.503-65.504l3.805-3.805 c15.211-15.211,35.436-23.587,56.948-23.587c14.958,0,29.558,4.121,42.218,11.917l5.118,3.15l30.61-30.612l31.607,31.607 l-30.61,30.61L408.239,143.637z M446.456,97.152l-31.607-31.607l10.757-10.758l31.608,31.607L446.456,97.152z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 341.814,
    y: 234.116,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 414.3051 686.9314)",
    style: {
      fill: "#FFFFFF"
    },
    width: 15.213,
    height: 47.089
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M385.811,232.045l-10.758-10.757c16.496-16.495,19.488-41.867,7.278-61.7l12.954-7.976 C411.206,177.471,407.309,210.547,385.811,232.045z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.7b0d5d6381e4a904d98d3e1fc17d570a.svg";
export { ForwardRef as ReactComponent };